import isEmpty from 'lodash/isEmpty';
import {
	ERROR_TYPES,
	MAX_URL_LENGTH,
	MAX_TITLE_LENGTH,
	MAX_DESCRIPTION_LENGTH,
} from '../../../../common/constants';

const trimValue = (value?: string): string => (value !== undefined ? value.trim() : '');

export const validateIsRequiredField = (value?: string): string | undefined => {
	const trimmedValue = trimValue(value);

	if (trimmedValue.length === 0) {
		return ERROR_TYPES.EMPTY;
	}

	return undefined;
};

export const validateSelectField = (
	linkType: {
		value: string;
	} | null,
): string | undefined => {
	if (isEmpty(linkType) || isEmpty(linkType.value)) {
		return ERROR_TYPES.EMPTY;
	}

	return undefined;
};

// This util can be used after MVP release when we thoroughly verify URLs
// till then, it can be used to check for the effectiveness of this regex in URL validation
export const isInvalidURL = (value?: string) => {
	const trimmedValue = trimValue(value);
	const regex =
		"^(ht|f)tp(s?)://[0-9a-zA-Z]([-.w]*[0-9a-zA-Z])*(:(0-9)*)*(/?)([a-zA-Z0-9-.?,'/\\+&amp;%$#_]*)?$";

	if (trimmedValue.match(regex)) {
		return false;
	}

	return true;
};

export const validateTextField = (name: string, value?: string) => {
	const error = validateIsRequiredField(value);

	if (error === undefined && value !== undefined) {
		switch (name) {
			case 'link':
				return value.length > MAX_URL_LENGTH ? ERROR_TYPES.CHAR_LIMIT_EXCEEDED : undefined;
			case 'title':
				return value.length > MAX_TITLE_LENGTH ? ERROR_TYPES.CHAR_LIMIT_EXCEEDED : undefined;
			case 'description':
				return value.length > MAX_DESCRIPTION_LENGTH ? ERROR_TYPES.CHAR_LIMIT_EXCEEDED : undefined;
			default:
				return undefined;
		}
	}

	return error;
};
